import React from "react";
import { Shield, Target, Clock, TrendingUp } from "lucide-react";
import { mockGuarantees } from "../data/mock";

const Guarantees = () => {
  const iconMap = {
    Shield: Shield,
    Target: Target,
    Clock: Clock,
    TrendingUp: TrendingUp
  };

  return (
    <section id="guarantees" style={{ background: 'var(--gradient-hero-subtle)' }} className="py-20">
      <div className="container">
        <div className="text-center mb-16">
          <div className="hero-announcement mb-6">
            <Shield size={12} style={{ color: 'var(--text-primary)' }} />
            <span>Risk-Free Implementation</span>
          </div>
          <h2 className="heading-1 mb-4">
            Our <span style={{ color: 'var(--accent-orange-400)' }}>Guarantee System</span>
          </h2>
          <p className="body-large" style={{ 
            maxWidth: '700px', 
            margin: '0 auto',
            color: 'var(--text-secondary)' 
          }}>
            We're so confident in our AI solution delivery that we back every project 
            with comprehensive guarantees for your peace of mind.
          </p>
        </div>

        <div className="voice-grid max-w-4xl mx-auto">
          {mockGuarantees.map((guarantee, index) => {
            const IconComponent = iconMap[guarantee.icon];
            
            return (
              <div 
                key={index} 
                className="voice-card hover-lift"
                style={{ background: 'var(--bg-card)' }}
              >
                <div className="flex items-start gap-4 mb-4">
                  <div 
                    className="p-3 rounded-full flex-shrink-0"
                    style={{ 
                      background: guarantee.accentColor,
                      color: 'var(--text-primary)' 
                    }}
                  >
                    <IconComponent size={24} />
                  </div>
                  <div className="flex-1">
                    <h3 className="voice-card-title mb-2">
                      {guarantee.title}
                    </h3>
                    <div className="body-small mb-3" style={{ 
                      color: guarantee.textColor,
                      fontWeight: '600' 
                    }}>
                      {guarantee.promise}
                    </div>
                  </div>
                </div>
                
                <div className="voice-card-description mb-4">
                  {guarantee.description}
                </div>

                <div className="border-t pt-4" style={{ borderColor: 'var(--border-light)' }}>
                  <div className="flex items-center justify-between">
                    <div className="caption">
                      Coverage: {guarantee.coverage}
                    </div>
                    <div 
                      className="mono-text font-semibold"
                      style={{ color: guarantee.textColor }}
                    >
                      {guarantee.terms}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-16">
          <div className="inline-flex flex-col items-center gap-4 p-8 rounded-lg max-w-md mx-auto" style={{ background: 'var(--bg-card)' }}>
            <div className="p-4 rounded-full" style={{ background: 'var(--accent-green-200)' }}>
              <Shield size={32} style={{ color: 'var(--text-primary)' }} />
            </div>
            <div className="text-center">
              <h3 className="heading-3 mb-2">100% Risk-Free</h3>
              <p className="body-small mb-4" style={{ color: 'var(--text-secondary)' }}>
                Start your AI transformation with complete confidence
              </p>
              <button className="btn-primary hover-scale">
                Get Started Today
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guarantees;